import { capitalizeFirstLetter } from '@/utils/strings';

export const METRIC_UNITS = [
  'g',
  'kg',
  'mg',  
  'ml',
  'l',  
];

export const IMPERIAL_UNITS = [
  'oz',
  'lb',
  'fl oz',  
  'pint',
  'quart',
  'gallon',
];

export const COMMON_UNITS = [
  'tsp',
  'tbsp',
  'cup',
  'pinch',
  'piece',
  'slice',
  'clove',
  'dash',
  'to taste',
  'none',  
];

export const FRACTIONAL_UNITS = [
  'tsp',
  'tbsp',
  'cup'
];

export const ALL_UNITS = [
  ...METRIC_UNITS,
  ...IMPERIAL_UNITS,
  ...COMMON_UNITS,
];

// Units whose written form is a symbol rather than a word. "G" or "Ml" reads as
// a typo, so these keep the casing they are stored in; the word-like units
// ("pinch", "to taste") are capitalized like any other label.
const SYMBOL_UNITS = new Set(['g', 'kg', 'mg', 'ml', 'l', 'oz', 'lb', 'fl oz', 'tsp', 'tbsp']);

export function unitLabel(unit) {
  return SYMBOL_UNITS.has(unit) ? unit : capitalizeFirstLetter(unit);
}

const isSymbolUnit = (unit) => SYMBOL_UNITS.has(unit);

// Display order, which is not the same as ALL_UNITS: symbols first so the
// lowercase labels sit together, then the word-like units. Partitioning rather
// than listing them again keeps this in step with the lists above, and the
// metric → imperial → common order survives inside each half.
export const ALL_UNITS_OPTIONS = [
  ...ALL_UNITS.filter(isSymbolUnit),
  ...ALL_UNITS.filter((unit) => !isSymbolUnit(unit)),
].map(unit => ({
  value: unit,
  label: unitLabel(unit),
}));

export const units = [
  {value: 'metric', label: 'Metric', description: 'grams (g), milliliters (ml), kilograms (kg), etc.'},
  {value: 'imperial', label: 'US/Imperial', description: 'ounces (oz), pounds (lb), cups, etc.'},
];

